export class SPIDUser {
  public ID: number;
  public domicilePostalCode: string;
  public placeOfBirth: string;
  public address: string;
  public gender: string;
  public idCard: string;
  public domicileMunicipality: string;
  public spidCode: string;
  public dateOfBirth: string;
  public domicileStreetAddress: string;
  public domicileProvince: string;
  public mobilePhone: string;
  public familyName: string;
  public name: string;
  public domicileNation: string;
  public countyOfBirth: string;
  public fiscalNumber: string;
  public email: string;
  public expirationDate: string;
  public digitalAddress: string;
  public level: object;
  public reqId: string;
  public assertionId: string;
}

